export default "//yastatic.net/s3/distribution/pythia/frontend/_/89675bf66156380a0868cddc4050cc65.png";